import {
  Color,
  TextStyle,
  TextAlignKinds,
} from "../../../../domain/drawing";
import {
  AbstractTextItem,
  instanceOfINumericRangeValidatable,
} from "../../../../domain/document/items";
import { ITextStyleReadable } from "..";
import { AbstractObjectStyleReader } from "./AbstractObjectStyleReader";

export abstract class AbstractTextObjectStyleReader<T extends AbstractTextItem> extends AbstractObjectStyleReader<T> implements ITextStyleReadable {
  public abstract readTextStyle(source: T, shouldInputFree: boolean, isFocused: boolean): TextStyle;

  protected toTextStyle(source: T): TextStyle {
    const style = source.textStyle.clone();
    return new TextStyle(
      this.toValidatedTextColor(source),
      style.textAlign,
      style.baseFontSize,
      style.adjustedFontSize,
      style.fontFamily,
      style.lineHeight,
      style.isMultiLine,
    );
  }

  protected toFreeInputTextStyle(source: T): TextStyle {
    const result = this.toTextStyle(source);
    result.textAlign = (result.textAlign & TextAlignKinds.Vertical) | TextAlignKinds.Left;  // フリー入力時は左寄せ.
    return result;
  }

  protected toObjectNameTextStyle(source: T): TextStyle {
    const result = this.toTextStyle(source);
    result.color.value = "#E4C400";                                                         // TODO: これは設定に持つべき.
    return result;
  }

  protected toErrorTextStyle(source: T): TextStyle {
    const result = this.toTextStyle(source);
    result.color.value = "red";                                                             // TODO: これは設定に持つべき.
    result.adjustedFontSize = result.baseFontSize;                                          // 縮小を考慮しないサイズで描く.
    result.textAlign = TextAlignKinds.MiddleCenter;                                         // 位置は中央中寄せ.
    return result;
  }
  
  private toValidatedTextColor(source: T): Color {
    if (instanceOfINumericRangeValidatable(source)) {
      const alertColor = source.getNumericRangeAlertColor();
      if (alertColor) {
        return new Color(alertColor);
      }
    }
    return source.textStyle.color.clone();
  }
}
